import { FC } from 'react'
import { Outlet } from 'react-router-dom'
import './profile.css'

// COMPONENTS
import { Column } from '@components/templates/column'

// ROUTES
import { ConnectedAccountsRoute } from './connected-accounts'
import { DeleteAccountRoute } from './delete-account'
import { DefaultRoute } from './default'
import { EmailRoute } from './email'
import { PhoneRoute } from './phone'
import { SMSSettingsRoute } from './sms-settings'

// TYPES
import type { RouteObject } from 'react-router-dom'


const Component: FC = () => (
    <Column.Content className="account-profile-screen">
        <Outlet />
    </Column.Content>
)

const ProfileRoute: RouteObject = {
    path: "profile",
    Component,
    children: [
        ConnectedAccountsRoute,
        DeleteAccountRoute,
        DefaultRoute,
        EmailRoute,
        PhoneRoute,
        SMSSettingsRoute
    ]
}

export { ProfileRoute }
